module.exports = __webpack_public_path__ + "static/media/Plus_Icon_Billing.49614440.svg";